module.exports = __webpack_public_path__ + "img/wind.a7380089.svg";